<div class="card">
    <div class="card-header">
        <h1>
            Left Rail
        </h1>
    </div>
    <div class="card-body">
        This is body text
    </div>
</div>